// Function to update the selected variant when a color is chosen
function updateSelectedVariant(input) {
  // Get all option selectors on the page
  const optionSelectors = document.querySelectorAll("[data-option-position]")
  const selectedOptions = []

  // Build array of currently selected options
  optionSelectors.forEach((selector) => {
    if (selector.checked || selector.selected) {
      const optionPosition = Number.parseInt(selector.getAttribute("data-option-position"))
      selectedOptions[optionPosition - 1] = selector.value
    }
  })

  // Update the displayed selected option value
  const optionPosition = Number.parseInt(input.getAttribute("data-option-position"))
  const selectedValueDisplay = document.querySelector(".selected-option-value")
  if (selectedValueDisplay) {
    selectedValueDisplay.textContent = input.value
  }

  // Update the selected class for styling
  const allSwatches = document.querySelectorAll(".color-swatch-wrapper")
  allSwatches.forEach((swatch) => {
    swatch.classList.remove("selected")
  })

  input.closest(".color-swatch-wrapper").classList.add("selected")

  // Find the matching variant
  const variants = JSON.parse(document.getElementById("product-variants-json").textContent)
  let matchingVariant = null

  for (const variant of variants) {
    const variantOptions = variant.options
    let isMatch = true

    for (let i = 0; i < selectedOptions.length; i++) {
      if (selectedOptions[i] && variantOptions[i] !== selectedOptions[i]) {
        isMatch = false
        break
      }
    }

    if (isMatch) {
      matchingVariant = variant
      break
    }
  }

  // Update the variant selector if a matching variant was found
  if (matchingVariant) {
    const variantSelector = document.getElementById("ProductSelect-product-template")
    if (variantSelector) {
      variantSelector.value = matchingVariant.id

      // Trigger change event to update other elements on the page
      const event = new Event("change", { bubbles: true })
      variantSelector.dispatchEvent(event)
    }
  }
}

// Initialize the color swatches on page load
document.addEventListener("DOMContentLoaded", () => {
  // Add the variants data to the page for the script to use
  const productJson = document.getElementById("ProductJson-product-template")
  if (productJson) {
    const productData = JSON.parse(productJson.textContent)

    // Create a hidden element with variant data
    const variantsJson = document.createElement("script")
    variantsJson.type = "application/json"
    variantsJson.id = "product-variants-json"
    variantsJson.textContent = JSON.stringify(productData.variants)
    document.body.appendChild(variantsJson)
  }
})
